module.exports = new __parcel__URL__("a-saucerful-of-secrets.6685f1af.jpg").toString();